/* eslint-disable import/prefer-default-export */
import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { cryptodraftScreens } from '../../../screens/Card/Cryptodraft/constants';
import { cryptodraft } from './reducer';

const initCryptodraftState = {
  currentScreen: cryptodraftScreens.PROMO,
  screenOptions: {},
  termsOpened: false,
  isExtendCryptodraft: false,
  allowedWallets: [],
  allowedSettlementWallets: [],
  selectedSettlementWallet: {},
  selectedWallet: {},
  collateralAmount: 0,
  cryptodraftDetails: null,
  cryptodraftSettlementDetails: null,
  cryptodraftSettings: null,
  cryptodraftTierLTV: null,
  additionalAmountNeeded: null,
  fiatCurrency: null,
  principalCurrency: null,
  user: {
    isUS: false,
    cardProvider: null,
  },
  pgwRequestParams: {},
  hintsOpened: {
    first: false,
    second: false,
    third: false,
  },
  forceUpdate: {
    allowedWallets: false,
    cryptodraftDetails: false,
    cryptodraftSettlementDetails: false,
  },
  forceReset: {
    selectedSettlementWallet: false,
  },
};

export const CryptodraftContext = createContext(initCryptodraftState);

export const CryptodraftProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cryptodraft?.CryptodraftReducer, initCryptodraftState);

  const boundActions = {};
  // eslint-disable-next-line guard-for-in, guard-for-in
  for (const key in cryptodraft?.actions) {
    boundActions[key] = cryptodraft.actions[key](dispatch);
  }

  return (
    <CryptodraftContext.Provider value={{ state, ...boundActions }}>
      {children}
    </CryptodraftContext.Provider>
  );
};

CryptodraftProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};
